import { Button, ButtonProps } from '@mui/material';
export const ButtonComponent: React.FC<ButtonProps> = props => {
  return <Button {...props}>{props.children}</Button>;
};
